import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
  size?: 'normal' | 'small';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const isSmall = size === 'small';

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${isSmall ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={movie.coverImage}
          alt={movie.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {movie.isHot && (
          <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            热播
          </span>
        )}
        {movie.isNew && (
          <span className={`absolute top-2 ${movie.isHot ? 'left-12' : 'left-2'} px-1.5 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap`}>
            更新
          </span>
        )}

        <div className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-xs font-semibold bg-background-950/70 text-primary-400 whitespace-nowrap">
          {movie.rating}
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-background-100 line-clamp-2 leading-relaxed">
            {movie.description}
          </p>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className={`font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 ${isSmall ? 'text-sm' : 'text-sm md:text-base'}`}>
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{movie.subCategory}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
          <span className="text-xs text-foreground-500">{movie.year}</span>
        </div>
        {movie.status === '连载中' && (
          <p className="text-xs text-accent-500 mt-0.5">{movie.updateInfo}</p>
        )}
      </div>
    </Link>
  );
}